var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-3"},[_c(_vm.getBillingCurrentPage,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }